module.exports = __webpack_public_path__ + "static/media/yellow-triangle.44a9f48d.png";